export default "__VITE_ASSET__BMeFb1FF__"